.users__users-table-container {
  width: 100%;
  // TODO: better selectors
  & > * {
    height: auto;
  }
  & > * > nav > * {
    justify-content: left;
  }
}

.users__users-search-container {
  min-width: 300px;
  max-width: 500px;
}
